import { useEffect } from 'react';
import CollectionPage from './CollectionPage';

const heroImage = 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/73216bbc1fdd1ede590a70578815ecd9.webp';

export default function WindSpinners() {
  useEffect(() => { document.title = 'Wind Spinners — Laser Cut Stainless Steel | SpinWorld.Us'; }, []);
  return (
    <CollectionPage
      category="SPINNERS"
      title="Catch the Wind"
      subtitle="Laser cut stainless steel, 40+ designs"
      heroImage={heroImage}
      description="Our signature wind spinners are precision laser-cut from rustproof stainless steel and finished with vibrant, weather-resistant coatings. Every piece is designed to catch even the gentlest breeze and transform it into mesmerizing kinetic art for your garden, porch, or patio."
    />
  );
}